module.exports = __webpack_public_path__ + "static/media/target.28f36a9f.png";